import App from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootswatch/dist/simplex/bootstrap.css';

ReactDOM.render(<App />, document.getElementById('root'));